export default "assets/main-sparkles-ae7fca1e.png";